import React from "react";
import { SoonBadge } from "../../atoms/SoonBadge";
import type { AccessPolicySelectProps } from "./AccessPolicySelect.types";
import { Copy, Description, Group, IconBox, Option, Radio, Title } from "./AccessPolicySelect.styles";

/** A radio list of access policies (icon, title, description) with a slot for a warning under it. */
export function AccessPolicySelect<V extends string = string>({
  options,
  value,
  onChange,
  ariaLabel,
  warning,
  disabled = false,
  className,
}: AccessPolicySelectProps<V>) {
  return (
    <Group className={className}>
      <Group role="radiogroup" aria-label={ariaLabel}>
        {options.map((o) => {
          const selected = o.value === value;
          const off = disabled || o.disabled || o.comingSoon;
          return (
            <Option
              key={o.value}
              type="button"
              role="radio"
              aria-checked={selected}
              $selected={selected}
              disabled={Boolean(off)}
              onClick={() => onChange(o.value)}
            >
              {o.icon ? (
                <IconBox $selected={selected} aria-hidden>
                  {o.icon}
                </IconBox>
              ) : null}
              <Copy>
                <Title>
                  {o.label}
                  {o.comingSoon ? <SoonBadge size="sm" /> : null}
                </Title>
                {o.description ? <Description>{o.description}</Description> : null}
              </Copy>
              <Radio $selected={selected} aria-hidden />
            </Option>
          );
        })}
      </Group>
      {warning ?? null}
    </Group>
  );
}

export default AccessPolicySelect;
